var R={AFFIRMATIVE:"AFFIRMATIVE",ERROR:"ERROR",INFO:"INFO"};export{R as default};
//# sourceMappingURL=variantsConst.js.map
